/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import clsx from 'clsx';
import { hooks } from '@lifesize/clients.sdk';
import { colors } from '@lifesize/ux-assets';
import { ReactComponent as ChevronDownIcon } from '@lifesize/ux-assets/vectors/svgIcons/chevron-down.svg';
import { ReactComponent as ChevronUpIcon } from '@lifesize/ux-assets/vectors/svgIcons/chevron-up.svg';
import { makeStyles, Theme } from '@material-ui/core';
import { getFilteredParticipants } from './InCallParticipantList';
import WaitingRoomParticipant from './WaitingRoomParticipant';
import _get from 'lodash/get';

interface Props {
  searchTerm: string;
}

const WaitingRoomList = (props: Props) => {
  const classes = useStyles({});
  const { searchTerm } = props;
  const waitingRoomUsers = hooks.useWaitingRoomUsers().filter((participant) => !!participant.name); // ignore users that are processing (no name)
  const waitingRoomUsersCount = _get(waitingRoomUsers, 'length', 0);
  const [isListHidden, setIsListHidden] = useState(false);
  const ChevronIcon = isListHidden ? ChevronUpIcon : ChevronDownIcon;

  const filteredWaitingRoomUsers = getFilteredParticipants(waitingRoomUsers, searchTerm);

  return (
    <div className="listContainer fill50">
      <header className={clsx('listTitle', classes.flexHeader)}>
        <h6 data-testid="waitingRoomCount">
          <FormattedMessage
            data-testid={'waitingRoomCount'}
            id="components.inCall.waitingRoom.header"
            description="In call waiting Room header"
            defaultMessage="Waiting Room ({participants, number})"
            values={{ participants: waitingRoomUsersCount }}
          />
        </h6>
        {!!waitingRoomUsersCount && <ChevronIcon onClick={() => setIsListHidden(!isListHidden)} />}
      </header>
      <div className={clsx(classes.list, (isListHidden || !waitingRoomUsersCount) && 'isHidden')}>
        {!!searchTerm && !filteredWaitingRoomUsers.length && (
          <p className={classes.emptyListMessage}>
            <FormattedMessage
              id="components.inCall.participantList.noSearchResultsWaitingRoom"
              defaultMessage={'No waiting room users matched your search'}
            />
          </p>
        )}
        {filteredWaitingRoomUsers.map(
          (participant, index) =>
            participant?.name &&
            participant?.participantId && (
              <WaitingRoomParticipant
                key={`participant-${participant.participantId}-${index}`}
                participant={participant}
              />
            )
        )}
      </div>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  flexHeader: {
    display: 'flex',
    '& > h6': {
      flex: '0 1 auto',
      textAlign: 'left'
    },
    '& > svg': {
      color: colors.squadronBlue,
      cursor: 'pointer',
      height: '1.2rem',
      flex: '0 0 auto',
      marginLeft: theme.spacing(1),
      width: 'auto'
    }
  },
  emptyListMessage: {
    fontSize: '1.2em',
    padding: `0 ${theme.spacing(3)}px`
  },
  list: {
    flex: '0 1 auto',
    marginTop: theme.spacing(1),
    overflowX: 'hidden',
    overflowY: 'auto',
    width: '100%',
    '&.isHidden': {
      display: 'none'
    }
  }
}));

export default injectIntl(WaitingRoomList);
